module.exports = __webpack_public_path__ + "static/img/empty.03dc277c.png";